export enum UnitOfMeasureType {
  ft = 'ft',
  in = 'in',
}
